import { render } from "./P095.vue?vue&type=template&id=04c794f8&scoped=true"
import script from "./P095.vue?vue&type=script&lang=js"
export * from "./P095.vue?vue&type=script&lang=js"

import "./P095.vue?vue&type=style&index=0&id=04c794f8&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c794f8"]])

export default __exports__